export default "__VITE_ASSET__5231ff7a__"